import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProjetoFonteRecurso } from '../../../models/projeto-fonte-recurso.model';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ActivatedRoute } from '@angular/router';
import { ProjetoFonteRecursoService } from '../../../services/projeto-fonte-recurso.service';

@Component({
  selector: 'app-projeto-fonte-recurso-list',
  templateUrl: './projeto-fonte-recurso-list.component.html',
  styleUrls: ['./projeto-fonte-recurso-list.component.scss']
})
export class ProjetoFonteRecursoListComponent 
  extends BaseListComponent<ProjetoFonteRecurso> 
  implements OnInit, OnDestroy {

  fonteRecursoslist: ProjetoFonteRecurso[]

  constructor(
    private myService: ProjetoFonteRecursoService,
    public activatedRoute: ActivatedRoute
  ) {
    super();
  }
  
  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }
  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.fonteRecursoslist = res;
        this.loaded();
      })
    );
  }
  
  novo() {
    return ['/pre-projeto/admin/projeto-fonte-recurso/adicionar'];
  }

  editar(id: number) {
    return ['/pre-projeto/admin/projeto-fonte-recurso/', id];
  }
  
}
